import { DesktopLeftContainer } from 'components/DesktopLeftContainer';
import { MainContainer } from 'screens/Main/styled';
import { CheckoutContainer } from './styled';
import { CheckoutForm } from './Form';
import { ContributionRules } from 'components/Slate/ContributionRules';
import Spacing from 'components/Spacing';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { EventSelections } from 'helpers/event';
import { PaymentsData } from 'store/payments/types';
import { IUserData } from 'store/user/types';
import { FC } from 'react';

interface Props {
  candidates: CandidateType[];
  clientId?: number;
  donationAmount: number;
  eventSelections?: EventSelections;
  pageOwner: string;
  payments: PaymentsData[];
  user?: IUserData;
}

export const DECheckoutFlow: FC<Props> = ({
  candidates,
  clientId,
  donationAmount,
  eventSelections,
  pageOwner,
  payments,
  user,
}) => {
  return (
    <MainContainer>
      <DesktopLeftContainer />
      <CheckoutContainer>
        <CheckoutForm
          candidates={candidates}
          clientId={clientId}
          donationAmount={donationAmount}
          eventSelections={eventSelections}
          pageOwner={pageOwner}
          payments={payments}
          user={user}
        />
        <Spacing $size={70} />
        <ContributionRules />
        <Spacing $size={48.5} />
      </CheckoutContainer>
    </MainContainer>
  );
};
